/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

export default function EmptyBottle({ className, size = 'xlarge' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
        color: 'primary',
        fill: '#cce3fa',
      }}
      className={className}
      viewBox="0 0 120 120"
    >
      <rect width="77" height="4" x="1" y="97" rx="2"></rect>
      <rect width="32.3" height="4" x="87" y="97" rx="1.5"></rect>
      <path
        fillRule="evenodd"
        d="M78 89H2v8.5h63.902s5.901-1.089 6.881-1.966C73.763 94.657 78 89 78 89z"
        clipRule="evenodd"
      ></path>
      <path d="M107 83h.373A4.628 4.628 0 01112 87.627v2.128a2.5 2.5 0 11-5 0V83z"></path>
      <path d="M0 0H13V32H0z" transform="matrix(0 -1 -1 0 62.5 75.5)"></path>
      <path d="M0 0H3V32H0z" transform="matrix(0 -1 -1 0 62.5 81.5)"></path>
      <path d="M0 0H13V5H0z" transform="matrix(0 -1 -1 0 25.5 75.5)"></path>
      <path d="M0 0H3V5H0z" transform="matrix(0 -1 -1 0 25.5 81.5)"></path>
      <mask id="a" fill="#fff">
        <path
          fillRule="evenodd"
          d="M58.5 62.5H2.477C1.385 62.5.5 63.33.5 64.332v31.336c0 1.012.87 1.832 1.977 1.832H58.5"
          clipRule="evenodd"
        ></path>
      </mask>
      <path
        fill="currentColor"
        d="M58.5 60.5a2 2 0 110 4v-4zm-56.023 2v-2 2zm56.023 33a2 2 0 110 4v-4zm0-31H2.477v-4H58.5v4zm-56.023 0c-.035 0-.044.013-.036.005a.157.157 0 00.033-.05.3.3 0 00.026-.123h-4c0-2.24 1.919-3.832 3.977-3.832v4zm.023-.168v31.336h-4V64.332h4zm0 31.336a.27.27 0 00-.024-.11.183.183 0 00-.04-.058c-.019-.018-.014 0 .041 0v4C.4 99.5-1.5 97.915-1.5 95.668h4zm-.023-.168H58.5v4H2.477v-4z"
        mask="url(#a)"
      ></path>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        d="M55.5 63.517h9.61c1.953-.095 4.22.193 6.451 1.2 1.608.724 3.013 1.769 4.136 3.175l5.18 5.597c1.477 1.648 2.29 2.011 4.926 2.011H102.5"
      ></path>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M55.5 96.485h9.466c1.923.084 4.155-.169 6.353-1.05 1.584-.636 2.968-1.551 4.074-2.784l5.102-4.904c1.454-1.444 2.256-1.762 4.852-1.762l16.272.015h2.881V75.5h-2.899"
      ></path>
    </svg>
  );
}
